(function () {
  var BADGE = '.card-information .jdgm-prev-badge';

  function formatBadge(badge) {
    if (!badge || !badge.closest('.card-information')) return;

    var count = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
    var average = parseFloat(badge.getAttribute('data-average-rating'));
    var widget = badge.closest('.jdgm-preview-badge');
    var text = badge.querySelector('.jdgm-prev-badge__text');

    if (!text || isNaN(count) || isNaN(average)) return;

    if (count < 1) {
      if (widget) widget.classList.add('is-empty-rating');
      return;
    }

    if (widget) widget.classList.remove('is-empty-rating');

    var formattedAverage = average.toLocaleString(document.documentElement.lang || undefined, {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    });
    var label = formattedAverage + ' (' + count + ')';

    if (text.textContent !== label) text.textContent = label;
  }

  function formatAll(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (root && root.matches && root.matches(BADGE)) formatBadge(root);
    scope.querySelectorAll(BADGE).forEach(formatBadge);
  }

  function onMutations(mutations) {
    mutations.forEach(function (mutation) {
      var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      var badge = target && target.closest && target.closest('.jdgm-prev-badge');

      if (badge && badge.closest('.card-information')) formatBadge(badge);

      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        formatAll(node);
      });
    });
  }

  function boot() {
    formatAll(document);
    new MutationObserver(onMutations).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
